import styled from 'styled-components'
import IconComponent from './icon'
import TimeComponent from './time'
import TitleComponent from './title'

export const NoDuration = styled.div`
    align-items: center;
    box-sizing: border-box;
    display: flex;
    padding: 0 10px;
    width: 100%;
`

export const Thumbnail = styled.img`
    height: 34px;
    object-fit: contain;
    margin: 0 6px;
    pointer-events: none;
    width: 34px;
`

export const Title = styled(TitleComponent)`
    margin: 0 12px 0 6px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
`

export const Icon = styled(IconComponent)`
    flex-shrink: 0;
`

export const Time = styled(TimeComponent)`
    flex-shrink: 0;
    margin: 0 6px 0 12px;

    &:only-child {
        margin: 0 auto;
    }

    span {
        color: rgba(255, 255, 255, 0.5);
    }
`
